import { PlusOutlined } from '@ant-design/icons';
import { Card, Divider } from 'antd';
import React, { memo } from 'react';
import './AddProjectItem.scss';
import { t } from 'helpers/i18n';

type AddProjectItemProps = {
  onClick: () => void;
};

const AddProjectItem: React.FC<AddProjectItemProps> = ({ onClick }) => {
  return (
    <div className={'add-project-item-container'}>
      <Card
        hoverable
        className={'add-project-item-btn'}
        cover={
          <div>
            <div className="add-project-add-item-block">
              <div className="add-project-add-item-icon">
                <PlusOutlined style={{ fontSize: 32 }} />
              </div>
            </div>
            <Divider style={{ margin: '0' }} />
          </div>
        }
        onClick={() => onClick()}
      >
        <Card.Meta
          style={{ height: '56px' }}
          title={t('project_list_add_new_project')}
        />
      </Card>
    </div>
  );
};

export default memo(AddProjectItem);
